export enum ListItemMetaTypeEnum {
    Document = 'Document',
    Magnet = 'Magnet',
    Contact = 'Contact',
    Vault = 'Vault',
    Stamp = 'Stamp',
}
